export const maskConstants = {
    TOGGLE: 'MASK_TOGGLE'
};